import angular from 'angular';

/**
 * @ngdoc function
 * @name myConsultApp.controller:PetOwnerRewardsApplicationCtrl
 * @description
 * # PayPathCtrl
 * Controller of the myConsultApp
 */
angular
  .module('myConsultApp')
  .controller(
    'PetOwnerRewardsApplicationCtrl',
    ($scope, $http, ENV, $location, crumble, InvitationService, CmsService, $compile) => {
      if ($scope.isAdminUser || $scope.isSuperUser) {
        $location.path('/admin');
      }
      if (!$scope.isRewardsSubscribed) {
        $location.path('/find-a-pet');
      } else {
        $scope.emailError = false;
        $scope.sendInviteSuccessMsg = false;
        $scope.crumble = crumble;
        crumble.update();

        $scope.rewardsInviteForm = {
          email: '',
        };

        $scope.subscribeEmail = '';

        $scope.showAlerts = false;
        $scope.resourceHeader = 'Resources to help clients save on future veterinary visits:';
        $scope.resources = [];
        $scope.articlesHeader = 'Latest from Zoetis Petcare Blog:';
        $scope.articles = [];

        if (InvitationService.getEmail() !== '') {
          $scope.rewardsInviteForm.email = InvitationService.getEmail();
          InvitationService.storeEmail('');
        }

        CmsService.getCmsContent('pro-rewards-page-content').then((response) => {
          const $body = $(response.body);
          const $content = $body.find('p').first();
          if ($content.length > 0) {
            const temp = $compile($content)($scope);
            angular.element(document.getElementById('rewards-text')).text(temp.text());
          }
        });

        CmsService.getCmsContent('pro-rewards-alerts').then((response) => {
          const $body = $(response.body);
          const $content = $body.find('p').prepend('<i class="fa fa-exclamation-circle"></i> ');
          if ($content.length > 0) {
            $scope.showAlerts = true;
            $content.find('a').append('<i class="fa fa-caret-right"></i>');
            const temp = $compile($content)($scope);
            angular.element(document.getElementById('alert-bar')).append(temp);
          }
        });

        CmsService.getCmsContent('pro-rewards-downloadable-resources').then((response) => {
          let $body = $(response.body);
          $scope.resourceHeader = response.subtitle;

          if ($body.length === 1) {
            $body = $body.find('p');
          }
          $body.each(function () {
            const mainImage = $(this).find('img').first();
            const mainImgSrc = mainImage.attr('src')
              ? mainImage.attr('src')
              : 'images/resource-thumb.png';
            const mainImgAlt = mainImage.attr('title') ? mainImage.attr('title') : '';
            const mainImgWidth = mainImage.attr('width') ? mainImage.attr('width') : '';
            const mainImgHeight = mainImage.attr('height') ? mainImage.attr('height') : '';
            const item = {
              title: $(this).find('a').text(),
              link: $(this).find('a').attr('href'),
              linkTitle: $(this).find('a').attr('title'),
              img: {
                src: mainImgSrc,
                alt: mainImgAlt,
                width: mainImgWidth,
                height: mainImgHeight,
              },
            };
            $scope.resources.push(item);
          });
        });

        CmsService.getBlogArticles().then((response) => {
          response.forEach((article) => {
            var item = {
              img: article?.metadata?.thumbnail_image?.url,
              title: article?.title,
              link: 'https://zoetispetcare.com/blog/article/' + article?.slug,
              teaser: article?.teaser,
            };
            $scope.articles.push(item);
          });
        });
      }
    },
  );
